import { PermissionsApiService } from '@anecdotes/auth-core';
import { Component, OnInit } from '@angular/core';
import { Observable, map } from 'rxjs';

@Component({
  selector: 'app-no-access',
  templateUrl: './no-access.component.html'
})
export class NoAccessComponent implements OnInit {
  permissionsExist$: Observable<boolean>;

  constructor(private permissionsApiService: PermissionsApiService) {}

  ngOnInit(): void {
    this.permissionsExist$ = this.permissionsApiService.getPermissions().pipe(map((permissionsObject) => !!permissionsObject.permissions.length));
  }
}
